import { useQuery } from "@tanstack/react-query";
import { fetchers } from "../fetchers";

const APP_METADATA_KEY = "app_metadata";

const useAppMetadata = () => {
  return useQuery({
    queryKey: [APP_METADATA_KEY],
    queryFn: fetchers.appMetadata.getAppMetadata,
    staleTime: 1000 * 60 * 2, // 2 minutes
    refetchInterval: 1000 * 60 * 2, // 2 minutes
  });
};

export const appMetadataHooks = {
  useAppMetadata,
};
